import commonPropTypes from '../../../../constants/commonPropTypes'
import React, { Component } from 'react'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

class FieldError extends Component {
  static propTypes = {
    ...commonPropTypes,
  }

  render() {
    const { className, elmId, error } = this.props

    return (
      <div data-elm-id={`${elmId}_error`} className={cx('error', className)}>
        {error}
      </div>
    )
  }
}

export default FieldError
